import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

const ThankYou = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="min-h-[60vh] flex items-center justify-center py-12 px-4 flex-grow">
      <div className="max-w-md w-full text-center bg-white rounded-lg shadow-lg p-12">
        <h1 className="text-3xl font-bold mb-4 text-gray-800">Thank You!</h1>
        <p className="text-gray-600 mb-2">Your quotation request has been submitted successfully.</p>
        <p className="text-gray-600 mb-6">We will contact you soon with more details.</p>
        <Link 
          to="/" 
          className="inline-block bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition"
        >
          Return to Home
        </Link>
      </div>
      </div>
      <Footer />
    </div>
  );
};

export default ThankYou;
